// @ts-nocheck
import * as React from 'react'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import { cn } from '@/lib/utils'

/**
 * Shared right-side drawer shell used by the /admin/organize kebab editors
 * (Settings, Payment, Admins, Tiebreakers, Clone). Wraps shadcn `Sheet` with a
 * sticky header, a scrollable body, and an optional sticky footer so every
 * editor gets consistent chrome. `onOpenChange(false)` (overlay click / Esc /
 * X) maps to `onClose()`, mirroring the previous MUI Dialog behaviour.
 */
export default function SidePanel({
  open,
  onClose,
  title,
  subtitle,
  description,
  children,
  footer,
  className,
  bodyClassName,
}: {
  open: boolean
  onClose: () => void
  title?: React.ReactNode
  // Small, muted eyebrow rendered above the prominent title — e.g. the
  // tournament/league/division name the drawer is acting on. Truncates so a
  // long name can't push the layout around; the action word stays the anchor.
  subtitle?: React.ReactNode
  description?: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
  className?: string
  // Override the default padded/scrolling body wrapper. Pass e.g.
  // "p-0 overflow-hidden flex" when the child owns its own scroll + sticky footer.
  bodyClassName?: string
}) {
  return (
    <Sheet open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <SheetContent
        side="right"
        className={cn('w-full sm:max-w-lg flex flex-col gap-0 p-0', className)}
      >
        {(title || subtitle || description) && (
          <SheetHeader className="p-6 pb-4 border-b text-left space-y-1">
            {subtitle && (
              <div
                className="text-xs font-medium text-muted-foreground truncate"
                title={typeof subtitle === 'string' ? subtitle : undefined}
              >
                {subtitle}
              </div>
            )}
            {title && <SheetTitle>{title}</SheetTitle>}
            {description && <SheetDescription>{description}</SheetDescription>}
          </SheetHeader>
        )}
        <div className={cn('flex-1 overflow-y-auto p-6', bodyClassName)}>{children}</div>
        {footer && <SheetFooter className="p-4 border-t">{footer}</SheetFooter>}
      </SheetContent>
    </Sheet>
  )
}
